import moment from 'moment';
import { DailyUsage, InstitutionDailyUsages } from './types';

export const groupUsageDataByMonth = (
  dailyUsages: InstitutionDailyUsages
): InstitutionDailyUsages => {
  const monthlyDataMap = new Map();

  dailyUsages.forEach((dailyUsage) => {
    const dateYearMonth = moment(dailyUsage.date).format('YYYY-MM');
    if (monthlyDataMap.has(dateYearMonth)) {
      const values: number[] = monthlyDataMap.get(dateYearMonth);
      values.push(dailyUsage.numLearners);
      monthlyDataMap.set(dateYearMonth, values);
    } else {
      monthlyDataMap.set(dateYearMonth, [dailyUsage.numLearners]);
    }
  });

  const dailyUsagesByMonth: DailyUsage[] = [];

  monthlyDataMap.forEach((values: number[], key: string) => {
    const sum = values.reduce((a, b) => a + b);
    const avg = sum / values.length;
    dailyUsagesByMonth.push({
      date: key,
      numLearners: avg,
    });
  });

  return dailyUsagesByMonth;
};
